import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { recordRouteChange } from "@/lib/perfTracking";

/**
 * Times each client-side navigation from the moment the URL changes until the
 * new route has actually painted, and records it for the admin dashboard.
 */
export function useRouteTiming() {
  const { pathname } = useLocation();
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    const start = performance.now();
    let raf2 = 0;
    const raf1 = requestAnimationFrame(() => {
      raf2 = requestAnimationFrame(() => {
        recordRouteChange(pathname, performance.now() - start);
      });
    });
    return () => {
      cancelAnimationFrame(raf1);
      cancelAnimationFrame(raf2);
    };
  }, [pathname]);
}
